<template>
  <div class="home_box">
    <!-- 顶部导航栏 -->
    <header class="site_header">
      <div class="header_inner">
        <!-- Logo -->
        <div class="logo" @click="$router.push('/')">
          <img src="@/assets/logo (2).png" alt="光星乐动" class="logo_img" />
        </div>

        <!-- 菜单导航 + 分类导航（合并为一个数组统一渲染） -->
        <nav class="header_nav">
          <div
            v-for="item in navAllItems"
            :key="item.name"
            :class="[
              'nav_menu_item',
              {
                active: item.type === 'menu' ? activeMenu === item.name : activeNav === item.catIndex
              }
            ]"
            @click="handleNavItemClick(item)"
          >
            <span class="nav_menu_text">{{ item.label }}</span>
          </div>
        </nav>

        <!-- 右侧：搜索 + 登录/充值 -->
        <div class="header_right">
          <!-- 搜索框 -->
          <div class="search_box" @click="Sousuo()">
            <img class="search_icon_img" src="../assets/sousuo2.png" alt="">
            <input type="text" placeholder="搜索内容" class="search_input" />
          </div>

          <!-- 登陆/充值按钮 -->
          <button
            v-if="!isLoggedIn"
            class="header_action_btn"
            @click="$router.push('/login')"
          >登录</button>
          <button
            v-else
            class="header_action_btn"
            @click="openRecharge"
          >
            <img src="@/assets/tiantong.png" class="header_coin_icon" alt="星动" />
            获取星动
          </button>
        </div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="main_container">
      <!-- 视图展示区域 -->
      <main class="content">
        <router-view
          :active-nav="activeNav"
          :nav-items="navItems"
          :nav-reload-signal="navReloadSignal"
          @showMinorProtection="handleShowMinorProtection"
        ></router-view>
        <!-- 底部信息 -->
        <footer class="site_footer">
          <div class="footer_inner">
            <!-- 上部：多列信息 -->
            <div class="footer_top">
              <!-- 品牌列 -->
              <div class="footer_col footer_brand">
                <img src="@/assets/logo (2).png" alt="光星乐动" class="footer_logo" />
                <p class="footer_desc">光星乐动 — 让每一次直播都充满星光与感动，打造属于年轻人的音乐直播社区。</p>
              </div>
              <!-- 快速链接 -->
              <div class="footer_col">
                <h4 class="footer_col_title">关于我们</h4>
                <a class="footer_link" @click="$router.push('/')">平台首页</a>
                <a class="footer_link" @click="$router.push('/zbjc')">发现精彩</a>
                <a class="footer_link" @click="openRecharge">充值星动</a>
              </div>
              <!-- 帮助中心 -->
              <div class="footer_col">
                <h4 class="footer_col_title">帮助中心</h4>
                <a class="footer_link" @click="$router.push('xieyi')">用户协议</a>
                <a class="footer_link" @click="$router.push('yinsi')">隐私政策</a>
                <a class="footer_link" @click="$router.push('zbgf')">直播规范</a>
              </div>
              <!-- 联系方式 -->
              <div class="footer_col">
                <h4 class="footer_col_title">联系方式</h4>
                <p class="footer_info_item">
                  <i class="el-icon-message"></i>
                  <span>guangxingledong@163.com</span>
                </p>
                <p class="footer_info_item">
                  <i class="el-icon-location"></i>
                  <span>北京市丰台区方庄南路15号楼7层1座808-51室</span>
                </p>
                <p class="footer_info_item">
                  <i class="el-icon-office-building"></i>
                  <span>北京光星影月文化传媒有限公司</span>
                </p>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </div>

    

    <!-- 充值弹窗 -->
    <div v-if="vipshow" class="recharge-overlay" @click.self="closeRecharge">
      <div class="recharge-panel">
        <!-- 头部 -->
        <div class="recharge-header">
          <div class="recharge-title-wrap">
            <div class="recharge-title-bar"></div>
            <h3 class="recharge-title">获取星动</h3>
          </div>
          <i class="el-icon-close" @click="closeRecharge"></i>
        </div>

        <!-- 充值选项：2列网格卡片 -->
        <div class="recharge-grid">
          <div
            v-for="(item, index) in rechargeList"
            :key="index"
            class="recharge-card"
            :class="{ active: selectedAmount === item.amount }"
            @click="selectAmount(item)"
          >
            <div v-if="selectedAmount === item.amount" class="card-check">✓</div>
            <img src="@/assets/tiantong.png" class="card-icon" alt="星动" />
            <div class="card-count">{{ item.count }}<span class="card-unit">星动</span></div>
            <div class="card-price">¥ {{ item.amount }}</div>
          </div>

          <!-- 自定义卡片 -->
          <div class="recharge-card custom-card" :class="{ active: !selectedAmount && customAmount }">
            <div v-if="!selectedAmount && customAmount" class="card-check">✓</div>
            <div class="custom-label">自定义金额</div>
            <div class="custom-input-row">
              <input
                v-model.number="customAmount"
                type="number"
                placeholder="输入金额"
                class="custom-input"
                @focus="selectedAmount = null"
              />
            </div>
            <div v-if="customAmount" class="custom-preview">
              = {{ customAmount }} 星动
            </div>
          </div>
        </div>

        <!-- 底部：支付按钮 -->
        <div class="recharge-footer">
          <button class="btn-recharge" :class="{ loading: isRechargeLoading }" :disabled="isRechargeLoading" @click="confirmRecharge">
            <span v-if="isRechargeLoading" class="loading-spinner"></span>
            <template v-else>
              <span>立即充值</span>
              <span class="btn-amount" v-if="(selectedAmount || customAmount)">¥ {{ selectedAmount || customAmount }}</span>
            </template>
          </button>
          <p class="recharge-tips">支付成功后即时到账 · 账单显示：光星乐动充值</p>
        </div>
      </div>
    </div>

    <!-- 扫码支付弹窗 -->
    <div v-if="showPayModal" class="pay-modal-overlay" @click.self="closePayModal">
      <div class="pay-modal-content">
        <div class="pay-modal-header">
          <h3>微信支付</h3>
          <i class="el-icon-close" @click="closePayModal"></i>
        </div>
        <div class="pay-modal-body">
          <p class="pay-order-no">订单号：{{ payOrderNo }}</p>
          <div class="pay-qrcode">
            <!-- 使用qrcode.js生成二维码 -->
            <canvas ref="payQrCanvas"></canvas>
          </div>
          <p class="pay-tips">请使用微信扫一扫完成支付</p>
        </div>
      </div>
    </div>
 
    <!-- 提示去登录的弹窗 -->
    <div v-if="showLoginModal" class="login-modal-overlay" @click.self="closeLoginModal">
      <div class="login-modal-content">
        <div class="login-modal-header">
          <h3>欢迎加入光星乐动</h3>
          <i class="el-icon-close" @click="closeLoginModal"></i>
        </div>
        <div class="login-modal-body">
          <p class="login-modal-desc">登录后即可解锁更多精彩功能：</p>
          <div class="login-features">
            <p class="feature-text">• 直播间实时评论互动，与主播零距离交流</p>
            <p class="feature-text">• 给喜欢的主播送礼物，表达你的支持</p>
            <p class="feature-text">• 关注主播，第一时间收到开播提醒</p>
            <p class="feature-text">• 申请成为主播，开启你的直播之旅</p>
            <p class="feature-text">• 参与直播间抽奖活动，赢取丰厚奖励</p>
            <p class="feature-text">• 查看直播回放，精彩不错过</p>
          </div>
          <p class="login-modal-tips">我们在光星乐动等你，快来加入吧！</p>
        </div>
        <div class="login-modal-footer">
          <button class="btn-login-later" @click="closeLoginModal">稍后登录</button>
          <button class="btn-login-now" @click="goToLogin">去登录</button>
        </div>
      </div>
    </div>

    <!-- 未成年人保护提示弹窗（未登录时显示） -->
    <div v-if="showMinorProtectionModal" class="minor-modal-overlay" @click.self="closeMinorModal">
      <div class="minor-modal-content">
        <div class="minor-modal-header">
          <h3>未成年人保护</h3>
          <i class="el-icon-close" @click="closeMinorModal"></i>
        </div>
        <div class="minor-modal-body">
          <p class="minor-modal-desc">根据《中华人民共和国未成年人保护法》及相关法律法规要求，我们为未成年人提供专项保护措施。</p>
          <div class="minor-protection-info">
            <p class="minor-info-title">未成年人保护模式说明：</p>
            <p class="minor-info-item">• 每日观看时长严格限制在40分钟以内，超时将自动锁定</p>
            <p class="minor-info-item">• 每日22:00至次日06:00为禁播时段，期间无法访问平台</p>
            <p class="minor-info-item">• 全面关闭充值、消费、打赏、会员购买等付费功能</p>
            <p class="minor-info-item">• 限制评论、等社交互动功能</p>
            <p class="minor-info-item">• 智能过滤并隐藏不适宜未成年人观看的内容</p>
            <p class="minor-info-item">• 实名认证后自动识别未成年人身份并启用保护模式</p>
            <p class="minor-info-item">• 家长可以放心让孩子使用</p>
            <p class="minor-info-item">• 提供青少年专属内容推荐，健康向上、寓教于乐</p>
          </div>
          <p class="minor-modal-tips">我们致力于为未成年人营造安全、健康的网络环境，建议家长陪同未成年人一起使用本平台</p>
        </div>
        <div class="minor-modal-footer">
          <button class="btn-minor-later" @click="closeMinorModal">稍后登录开启</button>
          <button class="btn-minor-now" @click="goToLoginFromMinor">立即登录开启</button>
        </div>
      </div>
    </div>
 </div>
</template>

<script>
import axios from 'axios'
import QRCode from 'qrcode'
export default {
  name: 'homeT',
  data() {
    return {
      // 是否显示登录提示弹窗
      showLoginModal: false,
      // 是否显示未成年人保护弹窗
      showMinorProtectionModal: false,
      // 当前选中的分类导航（-1=首页，0=音乐，1=乐器...）
      activeNav: -1,
      // 分类刷新信号：点击同分类时递增，强制子组件重新请求数据
      navReloadSignal: 0,
      // 分类列表（去掉"首页"，避免与菜单导航的"首页"重复）
      navItems: ['音乐', '乐器', '舞蹈', '颜值', '生活方式'],
      // 当前选中的菜单
      activeMenu: 'home',
      // 充值相关
      selectedAmount: 90,
      customAmount: '',
      // 扫码支付弹窗
      showPayModal: false,
      payOrderNo: '',
      payCodeUrl: '',
      // 充值按钮加载状态
      isRechargeLoading: false,
      rechargeList: [
        { count: 1, amount: 1 },
        { count: 10, amount: 10 },
        { count: 90, amount: 90 },
        { count: 100, amount: 100 },
        { count: 648, amount: 648 }
      ],
      // 导航列表
      navList: [
        { name: 'music', label: '音乐' },
        { name: 'instrument', label: '乐器' },
        { name: 'dance', label: '舞蹈' },
        { name: 'talkshow', label: '脱口秀' },
        { name: 'anime', label: '二次元' },
        { name: 'beauty', label: '颜值' },
        { name: 'talent', label: '才艺' },
        { name: 'lifestyle', label: '生活方式' },
        { name: 'groupdance', label: '团舞' },
        { name: 'cover', label: '翻唱' }
      ],
      // 基础菜单列表（始终显示）
      baseMenuList: [
        { name: 'home', label: '首页', icon: require('../assets/shoye_hui.png'), iconActive: require('../assets/shoye.png')},
        { name: 'discover', label: '发现精彩', icon:require('../assets/zhibo_hui.png'), iconActive:require('../assets/zhibo.png')},
        { name: 'live', label: '成为主播', icon: require('../assets/shipin_hui.png'), iconActive: require('../assets/shipin.png')},
        { name: 'settings', label: '设置', icon: require('../assets/gengduo_hui.png'), iconActive: require('../assets/gengduo.png')}
      ],
      // 登录后才显示的菜单
      profileMenu: { name: 'profile', label: '个人中心', icon: require('../assets/gr_hei.png'), iconActive: require('../assets/gr_liang.png') },
      // 推荐主播列表
      anchorList: []
    }
  },
  
  mounted() {
    // 检查用户是否已登录，未登录则显示登录提示弹窗
    if (!this.isLoggedIn) {
      this.showLoginModal = true
    }
    
    axios.get('https://guangxing.xiangyouhulian.cn/api/index/tuijianss').then(res => {
      console.log('推荐主播数据:', res.data.data)
      this.anchorList = res.data.data;
    }).catch(err => {
      console.error('获取推荐主播失败:', err)
    })
  },

  methods:{
    // 统一处理导航点击：菜单走 lanmu，分类走 handleNavClick
    handleNavItemClick(item) {
      if (item.type === 'category') {
        this.handleNavClick(item.catIndex)
      } else {
        this.lanmu(item)
      }
    },
    // 分类导航点击：切换分类，不在首页时先跳回首页；同时清除菜单高亮
    handleNavClick(index) {
      this.activeMenu = ''
      if (this.activeNav === index) {
        // 点击当前已选中的分类：activeNav 值不变，子组件 watcher 不触发
        // 递增 signal 强制子组件重新请求数据
        this.navReloadSignal++
      } else {
        this.activeNav = index
      }
      if (this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    lanmu(item){
      // 设置和开启直播需要登录：未登录只提示，不跳转、不高亮
      if(item.name === 'settings' || item.name === 'live'){
        if(!this.isLoggedIn){
          this.$message.warning('你还没有登录！');
          return;
        }
      }
      // 通过权限校验后才设置高亮并跳转
      this.activeMenu = item.name;
      this.activeNav = -1; // 点菜单时清除分类高亮，保证只有一个高亮
      if(item.name === 'settings'){
        this.$router.push('/shezhi');
      } else if(item.name === 'home'){
        this.$router.push('/');
      } else if(item.name === 'discover'){
        // 1 ~ 5 随机整数，包含1和5
        // const num = Math.floor(Math.random() * 5) + 1;
        this.$router.push('/zbjc');
      } else if(item.name === 'live'){
        this.$router.push('/kaibo');
      } else if(item.name === 'profile'){
        this.$router.push('/gr');
      }
    },
    //推荐主播-跳转
    TuiJianClick(anchorid,id){
      console.log(anchorid,id);
      this.$router.push(`/zb/${id}/${anchorid}`);
    },
    // 选择充值金额
    selectAmount(item) {
      this.selectedAmount = item.amount
      this.customAmount = ''
    },
    // 打开充值弹窗
    openRecharge() {
      this.$store.commit('setVipshow', true)
    },
    // 关闭充值弹窗
    closeRecharge() {
      this.$store.commit('setVipshow', false)
    },
    // 关闭扫码支付弹窗
    closePayModal() {
      this.showPayModal = false
      this.payCodeUrl = ''
      this.payOrderNo = ''
    },
    // 生成支付二维码
    generateQrCode() {
      const canvas = this.$refs.payQrCanvas
      if (canvas && this.payCodeUrl) {
        QRCode.toCanvas(canvas, this.payCodeUrl, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        }).catch(err => {
          console.error('生成二维码失败:', err)
        })
      }
    },
    //搜索
    Sousuo() {
      this.$router.push('/search');
    },
    // 关闭登录提示弹窗
    closeLoginModal() {
      this.showLoginModal = false
      // 如果用户未登录，关闭登录弹窗后显示未成年人保护弹窗
      if (!this.isLoggedIn) {
        this.showMinorProtectionModal = true
      }
    },
    // 关闭未成年人保护弹窗
    closeMinorModal() {
      this.showMinorProtectionModal = false
    },
    // 从未成年人弹窗去登录
    goToLoginFromMinor() {
      this.closeMinorModal()
      this.$router.push('/login')
    },
    // 处理子组件触发的显示未成年人保护弹窗事件
    handleShowMinorProtection() {
      console.log('handleShowMinorProtection called')
      this.showMinorProtectionModal = true
      console.log('showMinorProtectionModal:', this.showMinorProtectionModal)
    },
    // 去登录
    goToLogin() {
      this.closeLoginModal()
      this.$router.push('/login')
    },
    // 确认充值
    confirmRecharge() {
      const amount = this.selectedAmount || this.customAmount
      if (!amount) {
        this.$message.error('请选择或输入充值金额')
        return
      }
      // 设置加载状态，防止重复点击
      this.isRechargeLoading = true
      // 调用创建订单接口
      axios.post('https://guangxing.xiangyouhulian.cn/api/index/createNative', {
        money: amount*100
      }).then(res => {
        // 关闭加载状态
        this.isRechargeLoading = false
        if (res.data.code === 1 && res.data.code_url) {
          // 显示扫码支付弹窗
          this.payOrderNo = res.data.order_no
          this.payCodeUrl = res.data.code_url
          this.showPayModal = true
          // 生成二维码
          this.$nextTick(() => {
            this.generateQrCode()
          })
        } else {
          this.$message.error(res.data.msg || '创建订单失败')
        }
      }).catch(err => {
        // 关闭加载状态
        this.isRechargeLoading = false
        this.$message.error('网络错误，请稍后重试')
        console.log(err)
      })
    },
  },
  computed: {
    vipshow() {
      return this.$store.state.vipshow
    },
    // 是否已登录
    isLoggedIn() {
      return this.$store.state.LoginStorage && this.$store.state.LoginStorage.id
    },
    // 根据登录状态返回菜单列表
    menuList() {
      if (this.isLoggedIn) {
        // 已登录，显示个人中心
        return [...this.baseMenuList, this.profileMenu]
      }
      // 未登录，不显示个人中心
      return this.baseMenuList
    },
    // 合并菜单导航 + 分类导航为一个数组，统一渲染
    // 顺序：首页-发现精彩-分类项-成为主播-设置-个人中心
    navAllItems() {
      const allMenus = this.menuList.map(item => ({ ...item, type: 'menu' }))
      const cats = this.navItems.map((label, index) => ({
        name: 'cat_' + index,
        label,
        type: 'category',
        catIndex: index
      }))
      // 菜单前两项（首页、发现精彩）放最前，分类居中，剩余菜单（成为主播、设置、个人中心）放最后
      const frontMenus = allMenus.filter(m => m.name === 'home' || m.name === 'discover')
      const backMenus = allMenus.filter(m => m.name !== 'home' && m.name !== 'discover')
      return [...frontMenus, ...cats, ...backMenus]
    }
  }
}
</script>

<style scoped>
/* ==================== B站直播风格 · 设计变量 ==================== */
/* 主色粉 #fb7299 / 悬浮 #ff85ad / 文字 #18191c·#61666d·#9499a0 / 边框 #e3e5e7 / 底色 #f4f4f5 */

.home_box {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background-color: #f4f4f5;
}

/* ==================== 顶部导航栏 ==================== */
.site_header {
  flex-shrink: 0;
  height: 56px;
  background-color: #ffffff;
  border-bottom: 1px solid #e3e5e7;
  z-index: 100;
}

.header_inner {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 24px;
}

/* Logo */
.logo {
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 100px;
  cursor: pointer;
  flex-shrink: 0;
}

.logo_img {
  height: 32px;
  width: auto;
}

/* 菜单导航 */
.header_nav {
  display: flex;
  align-items: center;
  height: 100%;
  flex: 1;
}

.nav_menu_item {
  position: relative;
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 16px;
  font-size: 14px;
  color: #61666d;
  cursor: pointer;
  transition: color 0.2s ease;
}

.nav_menu_item:hover {
  color: #fb7299;
}

.nav_menu_item.active {
  color: #fb7299;
  font-weight: 500;
}

.nav_menu_item.active::after {
  content: '';
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 0;
  height: 3px;
  background-color: #fb7299;
  border-radius: 3px 3px 0 0;
}

.nav_menu_icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  object-fit: contain;
}

.nav_menu_text {
  line-height: 1;
  white-space: nowrap;
}

/* 右侧区域 */
.header_right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

/* 搜索框 */
.search_box {
  display: flex;
  align-items: center;
  width: 200px;
  height: 32px;
  padding: 0 12px;
  background-color: #f1f2f3;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: text;
  transition: all 0.2s ease;
}

.search_box:hover {
  background-color: #ffffff;
  border-color: #e3e5e7;
}

.search_icon_img {
  width: 15px;
  height: 15px;
  margin-right: 6px;
  opacity: 0.55;
}

.search_input {
  flex: 1;
  width: 100%;
  font-size: 13px;
  color: #18191c;
  background: transparent;
  border: none;
  outline: none;
}

.search_input::placeholder {
  color: #9499a0;
}

/* 登录 / 获取星动 按钮 */
.header_action_btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 16px;
  font-size: 13px;
  color: #ffffff;
  background-color: #fb7299;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s ease;
}

.header_action_btn:hover {
  background-color: #ff85ad;
}

.header_coin_icon {
  width: 19px;
  height: 19px;
  margin-right: 5px;
}

/* ==================== 主内容区域 ==================== */
.main_container {
  display: flex;
  flex: 1;
  min-height: 0;
}

.content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: #f4f4f5;
}
/* 路由页面根节点填满剩余空间（子组件根元素带父级 scope 属性，可命中） */
.content > :not(.site_footer) {
  flex: 1 0 auto;
  min-height: 0;
}

/* ==================== 底部信息 ==================== */
.site_footer {
  flex-shrink: 0;
  margin-top: auto;
  padding: 36px 24px 28px;
  background: #303030;
}
.footer_inner {
  max-width: 1280px;
  margin: 0 auto;
}
/* 上部多列 */
.footer_top {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1.2fr;
  gap: 32px;
  padding-bottom: 24px;
}
.footer_col {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
/* 品牌列 */
.footer_brand {
  gap: 14px;
}
.footer_logo {
  width: 120px;
  height: auto;
  object-fit: contain;
}
.footer_desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.7;
  color: #8a8a9a;
  max-width: 320px;
}
/* 列标题 */
.footer_col_title {
  font-size: 14px;
  font-weight: 600;
  color: #d4d4dc;
  margin: 0 0 6px 0;
}
/* 链接 */
.footer_link {
  font-size: 13px;
  color: #8a8a9a;
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: none;
}
.footer_link:hover {
  color: #fb7299;
}
/* 信息项 */
.footer_info_item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  color: #8a8a9a;
  line-height: 1.6;
}
.footer_info_item i {
  flex-shrink: 0;
  margin-top: 3px;
  font-size: 14px;
  color: #6a6a7a;
}
/* 分隔线 */
.footer_divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #2a2a3e 20%, #2a2a3e 80%, transparent);
  margin-bottom: 20px;
}
/* 底部版权 */
.footer_bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}
.footer_copyright {
  margin: 0;
  font-size: 12px;
  color: #6a6a7a;
}
.footer_legal {
  display: flex;
  align-items: center;
  gap: 6px;
}
.footer_legal_link {
  font-size: 12px;
  color: #6a6a7a;
  cursor: pointer;
  transition: color 0.2s;
  text-decoration: none;
}
.footer_legal_link:hover {
  color: #fb7299;
}
.footer_dot {
  font-size: 12px;
  color: #4a4a5a;
}

/* ==================== 首页推荐主播侧栏 ==================== */
.anchor_rail {
  flex-shrink: 0;
  width: 220px;
  padding: 16px 14px;
  background-color: #ffffff;
  border-left: 1px solid #e3e5e7;
  overflow-y: auto;
}

.rail_title {
  padding: 0 4px;
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #18191c;
}

.anchor_list {
  list-style: none;
}

.anchor_item {
  display: flex;
  align-items: center;
  padding: 8px 4px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.anchor_item:hover {
  background-color: #f7f7f8;
}

.anchor_avatar_wrap {
  position: relative;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  flex-shrink: 0;
  border-radius: 50%;
  padding: 1.5px;
  border: 2px solid #fb7299;
}

.anchor_avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 50%;
}

.live_badge {
  position: absolute;
  bottom: -7px;
  left: 50%;
  transform: translateX(-50%);
  padding: 1px 6px;
  font-size: 10px;
  line-height: 1.5;
  color: #ffffff;
  background: #fb7299;
  border-radius: 4px;
  white-space: nowrap;
}

.anchor_info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.anchor_name {
  max-width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
  font-weight: 500;
  color: #18191c;
  margin-bottom: 3px;
}

.anchor_subtitle {
  max-width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  color: #9499a0;
}

/* 公司信息 */
.company_section {
  margin-top: 20px;
  padding-top: 14px;
  border-top: 1px solid #f1f2f3;
}

.company_copyright {
  font-size: 11px;
  line-height: 1.8;
  color: #b4b8bf;
}

/* ==================== 弹窗通用 ==================== */
.recharge-overlay,
.pay-modal-overlay,
.login-modal-overlay,
.minor-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ==================== 充值弹窗 ==================== */
.recharge-panel {
  width: 360px;
  background: #ffffff;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: popIn 0.25s ease;
}

.recharge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 22px 16px;
}

.recharge-title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.recharge-title-bar {
  width: 4px;
  height: 18px;
  background: linear-gradient(180deg, #fb7299, #ffb4c8);
  border-radius: 2px;
}

.recharge-title {
  font-size: 17px;
  font-weight: 600;
  color: #18191c;
  margin: 0;
}

.recharge-header .el-icon-close {
  font-size: 18px;
  color: #9499a0;
  cursor: pointer;
  transition: color 0.2s;
}

.recharge-header .el-icon-close:hover {
  color: #fb7299;
}

/* 网格卡片容器 */
.recharge-grid {
  padding: 4px 22px 16px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.recharge-card {
  position: relative;
  padding: 18px 10px 16px;
  background: #fafbfc;
  border: 1.5px solid #eaecef;
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease;
}

.recharge-card:hover {
  border-color: #ffb4c8;
  background: #fff7fa;
}

.recharge-card.active {
  background: linear-gradient(180deg, #fff7fa 0%, #fff 100%);
  border-color: #fb7299;
  box-shadow: 0 0 0 3px rgba(251, 114, 153, 0.12);
}

/* 选中角标 */
.card-check {
  position: absolute;
  top: 6px;
  right: 8px;
  width: 18px;
  height: 18px;
  background: #fb7299;
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  font-weight: bold;
}

.card-icon {
  width: 32px;
  height: 32px;
  margin-bottom: 8px;
}

.card-count {
  font-size: 20px;
  font-weight: 700;
  color: #18191c;
  line-height: 1.1;
  margin-bottom: 4px;
}

.card-count .card-unit {
  font-size: 12px;
  font-weight: 400;
  color: #61666d;
  margin-left: 2px;
}

.card-price {
  font-size: 13px;
  color: #9499a0;
}

.recharge-card.active .card-count {
  color: #fb7299;
}

.recharge-card.active .card-price {
  color: #fb7299;
  font-weight: 500;
}

/* 自定义卡片 */
.custom-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-label {
  font-size: 14px;
  color: #61666d;
  margin-bottom: 10px;
}

.custom-input-row {
  width: 100%;
}

.custom-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #e3e5e7;
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
  outline: none;
  background: #fff;
  color: #18191c;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.custom-input:focus {
  border-color: #fb7299;
}

.custom-preview {
  margin-top: 8px;
  font-size: 12px;
  color: #fb7299;
  font-weight: 500;
}

/* 底部 */
.recharge-footer {
  padding: 8px 22px 22px;
}

.btn-recharge {
  width: 100%;
  padding: 13px 0;
  background: linear-gradient(135deg, #fb7299, #ff85ad);
  border: none;
  border-radius: 24px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: opacity 0.2s;
}

.btn-recharge:hover {
  opacity: 0.92;
}

.btn-recharge.loading {
  background: #c9ccd2;
  cursor: not-allowed;
}

.btn-amount {
  font-size: 13px;
  font-weight: 500;
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
}

.recharge-tips {
  font-size: 12px;
  color: #9499a0;
  text-align: center;
  margin: 12px 0 0 0;
  line-height: 1.6;
}

.loading-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid #fff;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ==================== 扫码支付弹窗 ==================== */
.pay-modal-content {
  width: 340px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e3e5e7;
  overflow: hidden;
  animation: popIn 0.25s ease;
}

.pay-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 22px;
  border-bottom: 1px solid #f1f2f3;
}

.pay-modal-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #18191c;
  margin: 0;
}

.pay-modal-header .el-icon-close {
  font-size: 18px;
  color: #9499a0;
  cursor: pointer;
}

.pay-modal-header .el-icon-close:hover {
  color: #fb7299;
}

.pay-modal-body {
  padding: 22px;
  text-align: center;
}

.pay-order-no {
  font-size: 12px;
  color: #9499a0;
  margin-bottom: 16px;
}

.pay-qrcode {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.pay-qrcode canvas {
  border-radius: 8px;
}

.pay-tips {
  font-size: 13px;
  color: #61666d;
}

/* ==================== 登录提示弹窗 ==================== */
.login-modal-content {
  width: 400px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e3e5e7;
  overflow: hidden;
  animation: popIn 0.25s ease;
}

.login-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f2f3;
}

.login-modal-header h3 {
  font-size: 17px;
  font-weight: 600;
  color: #18191c;
  margin: 0;
}

.login-modal-header .el-icon-close {
  font-size: 18px;
  color: #9499a0;
  cursor: pointer;
}

.login-modal-header .el-icon-close:hover {
  color: #fb7299;
}

.login-modal-body {
  padding: 22px 24px;
}

.login-modal-desc {
  font-size: 14px;
  color: #18191c;
  margin-bottom: 14px;
}

.login-features {
  margin-bottom: 18px;
}

.login-features .feature-text {
  font-size: 13px;
  color: #61666d;
  line-height: 2.1;
  margin: 0;
}

.login-modal-tips {
  font-size: 12px;
  color: #9499a0;
  margin: 0;
  padding-top: 14px;
  border-top: 1px solid #f1f2f3;
}

.login-modal-footer {
  padding: 0 24px 24px;
  display: flex;
  gap: 12px;
}

.btn-login-later {
  flex: 1;
  padding: 11px 0;
  background: #f1f2f3;
  border: none;
  border-radius: 8px;
  color: #61666d;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-login-later:hover {
  background: #e8e9eb;
}

.btn-login-now {
  flex: 1;
  padding: 11px 0;
  background: #fb7299;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-login-now:hover {
  background: #ff85ad;
}

/* ==================== 未成年人保护弹窗 ==================== */
.minor-modal-content {
  width: 430px;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e3e5e7;
  overflow-y: auto;
  animation: popIn 0.25s ease;
}

.minor-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f2f3;
}

.minor-modal-header h3 {
  font-size: 17px;
  font-weight: 600;
  color: #18191c;
  margin: 0;
}

.minor-modal-header .el-icon-close {
  font-size: 18px;
  color: #9499a0;
  cursor: pointer;
}

.minor-modal-header .el-icon-close:hover {
  color: #fb7299;
}

.minor-modal-body {
  padding: 22px 24px;
}

.minor-modal-desc {
  font-size: 13px;
  color: #61666d;
  margin-bottom: 16px;
  line-height: 1.7;
}

.minor-protection-info {
  background: #fff7fa;
  border-radius: 8px;
  padding: 16px 18px;
  border-left: 3px solid #fb7299;
  margin-bottom: 16px;
}

.minor-info-title {
  font-size: 13px;
  color: #18191c;
  margin: 0 0 10px 0;
  font-weight: 600;
}

.minor-info-item {
  font-size: 12.5px;
  color: #61666d;
  line-height: 2;
  margin: 0;
}

.minor-modal-tips {
  font-size: 12px;
  color: #9499a0;
  margin: 0;
  line-height: 1.6;
}

.minor-modal-footer {
  padding: 0 24px 24px;
  display: flex;
  gap: 12px;
}

.btn-minor-later {
  flex: 1;
  padding: 11px 0;
  background: #f1f2f3;
  border: none;
  border-radius: 8px;
  color: #61666d;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-minor-later:hover {
  background: #e8e9eb;
}

.btn-minor-now {
  flex: 1;
  padding: 11px 0;
  background: #fb7299;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-minor-now:hover {
  background: #ff85ad;
}

/* ==================== 动画 ==================== */
@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
